

// // src/components/Header.jsx

// import React, { useState } from 'react';
// import { Globe, Menu, X } from 'lucide-react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { useLanguage } from '../context/LanguageContext';
// import logo_icon from "../assets/s.png"
// const Header = ({ content }) => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { language, setLanguage } = useLanguage();
//   const [isMenuOpen, setIsMenuOpen] = useState(false);

//   const t = content[language];

//   // Check if we're on the home page
//   const isHomePage = location.pathname === '/';

//   // Smooth scroll function for home page
//   const handleScrollTo = (e, targetId) => {
//     e.preventDefault();
//     setIsMenuOpen(false); // Close mobile menu
    
//     // If we're not on home page, navigate to home first
//     if (!isHomePage) {
//       navigate('/');
//       // Wait for navigation to complete, then scroll
//       setTimeout(() => {
//         const element = document.getElementById(targetId);
//         if (element) {
//           element.scrollIntoView({ 
//             behavior: 'smooth',
//             block: 'start'
//           });
//         }
//       }, 100);
//     } else {
//       // Already on home page, just scroll
//       const element = document.getElementById(targetId);
//       if (element) {
//         element.scrollIntoView({ 
//           behavior: 'smooth',
//           block: 'start'
//         });
//       }
//     }
//   };

//   // Handle blogs navigation
//   const handleBlogsClick = (e) => {
//     e.preventDefault();
//     setIsMenuOpen(false); // Close mobile menu
//     navigate('/blogs');
//     window.scrollTo(0, 0);
//   };

//   const handleContactClick = (e) => {
//     e.preventDefault();
//     setIsMenuOpen(false); // Close mobile menu
//     navigate('/contact');
//     window.scrollTo(0, 0);
//   };

//   // Handle logo click
//   const handleLogoClick = (e) => {
//     e.preventDefault();
//     setIsMenuOpen(false); // Close mobile menu
//     if (!isHomePage) {
//       navigate('/');
//     } else {
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     }
//   };

//   return (
//     <>
//       <style>{`
//         .header {
//           background: linear-gradient(135deg, #ffffff 0%, #fff5f2 100%);
//           box-shadow: 0 4px 20px rgba(0,0,0,0.08);
//           position: sticky;
//           top: 0;
//           z-index: 1000;
//           backdrop-filter: blur(10px);
//         }

//         .header-content {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           padding: 16px 0;
//           max-width: 1200px;
//           margin: 0 auto;
//           padding-left: 20px;
//           padding-right: 20px;
//         }

//         .logo-section {
//           display: flex;
//           align-items: center;
//           gap: 12px;
//           cursor: pointer;
//         }

//         .logo-icon {
//           width: 55px;
//           height: 55px;
//           // background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
//           border-radius: 8px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           // box-shadow: 0 4px 12px rgba(255, 107, 53, 0.3);
//         }
//         .logo-icon img{
//         width:100%}

//         .logo-text h1 {
//           font-size: 20px;
//           color: #1a1a1a;
//     font-weight: 700;
//     background: linear-gradient(135deg, #1a1a1a 0%, #ff6b35 100%);
//     -webkit-background-clip: text;
//     -webkit-text-fill-color: transparent;
//     background-clip: text;
//         }

//         .logo-text p {
//           font-size: 12px;
//           color: #666;
//           font-weight:bold
//         }

//         .nav {
//           display: flex;
//           gap: 32px;
//         }

//         .nav a {
//           color: #333;
//           text-decoration: none;
//           font-weight: 500;
//           transition: color 0.3s;
//           cursor: pointer;
//           position: relative;
//         }

//         .nav a:hover {
//           color: #ff6b35;
//         }

//         .nav a.active {
//           color: #ff6b35;
//         }

//         .nav a.active::after {
//           content: '';
//           position: absolute;
//           bottom: -8px;
//           left: 0;
//           right: 0;
//           height: 3px;
//           background: linear-gradient(90deg, #ff6b35, #ff8c42);
//           border-radius: 2px;
//         }

//         .right-section {
//           display: flex;
//           align-items: center;
//           gap: 5px;
//         }

//         .lang-btn {
//           padding: 10px 20px;
//           background: #fff5f2;
//           color: #ff6b35;
//           border: none;
//           border-radius: 8px;
//           font-weight: 600;
//           cursor: pointer;
//           transition: background 0.3s;
//           font-family: 'Poppins', sans-serif;
//         }

//         .lang-btn:hover {
//           background: #ffe5dc;
//         }

//         .hamburger-btn {
//           display: none;
//           background: none;
//           border: none;
//           cursor: pointer;
//           padding: 8px;
//           color: #333;
//           transition: color 0.3s;
//         }

//         .hamburger-btn:hover {
//           color: #ff6b35;
//         }

//         .mobile-nav {
//           display: none;
//           flex-direction: column;
//           gap: 0;
//           background: white;
//           border-top: 1px solid #f0f0f0;
//           box-shadow: 0 4px 12px rgba(0,0,0,0.1);
//         }

//         .mobile-nav.open {
//           display: flex;
//         }

//         .mobile-nav a {
//           color: #333;
//           text-decoration: none;
//           padding: 16px 20px;
//           font-weight: 500;
//           cursor: pointer;
//           transition: all 0.3s;
//           border-bottom: 1px solid #f5f5f5;
//         }

//         .mobile-nav a:hover {
//           background: #fff5f2;
//           color: #ff6b35;
//           padding-left: 30px;
//         }

//         .mobile-nav a.active {
//           color: #ff6b35;
//           background: #fff5f2;
//         }

//         @media (max-width: 768px) {
//           .nav {
//             display: none;
//           }

//           .hamburger-btn {
//             display: block;
//           }

//           .logo-text h1 {
//             font-size: 16px;
//           }

//           .logo-text p {
//             font-size: 10px;
//           }

//           .logo-icon {
//             width: 40px;
//             height: 40px;
//           }

//           .lang-btn {
//             padding: 8px 14px;
//             font-size: 14px;
//           }
//         }
//       `}</style>

//       <header className="header">
//         <div className="header-content">
//           <div 
//             className="logo-section"
//             onClick={handleLogoClick}
//           >
//             <div className="logo-icon">
//               {/* <Globe color="white" size={24} /> */}
//                <img src={logo_icon} alt='icon'/>
//             </div>
//             <div className="logo-text">
//               <h1>{language === 'mr' ? 'श्री एंटरप्रायजेस' : 'Shree Enterprises'}</h1>
//               <p>{language === 'mr' ? 'ई-सेवा केंद्र' : 'E-Seva Kendra'}</p>
//             </div>
//           </div>

//           {/* Desktop Navigation */}
//           <nav className="nav">
//             <a 
//               onClick={(e) => handleScrollTo(e, 'home')}
//               className={isHomePage ? 'active' : ''}
//             >
//               {t.nav.home}
//             </a>
//             <a 
//               onClick={(e) => handleScrollTo(e, 'services')}
//             >
//               {t.nav.services}
//             </a>
//             <a 
//               onClick={handleBlogsClick}
//               className={location.pathname === '/blogs' ? 'active' : ''}
//             >
//               {t.nav.blogs}
//             </a>
//             <a 
//               onClick={(e) => handleScrollTo(e, 'about')}
//             >
//               {t.nav.about}
//             </a>
//             <a 
//               onClick={handleContactClick}
//               className={location.pathname === '/contact' ? 'active' : ''}
//             >
//               {t.nav.contact}
//             </a>
//           </nav>

//           {/* Right Section - Language Button + Hamburger */}
//           <div className="right-section">
//             <button 
//               onClick={() => setLanguage(language === 'mr' ? 'en' : 'mr')} 
//               className="lang-btn"
//             >
//               {language === 'mr' ? 'EN' : 'मराठी'}
//             </button>

//             <button 
//               className="hamburger-btn"
//               onClick={() => setIsMenuOpen(!isMenuOpen)}
//             >
//               {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
//             </button>
//           </div>
//         </div>

//         {/* Mobile Navigation */}
//         <nav className={`mobile-nav ${isMenuOpen ? 'open' : ''}`}>
//           <a 
//             onClick={(e) => handleScrollTo(e, 'home')}
//             className={isHomePage ? 'active' : ''}
//           >
//             {t.nav.home}
//           </a>
//           <a 
//             onClick={(e) => handleScrollTo(e, 'services')}
//           >
//             {t.nav.services}
//           </a>
//           <a 
//             onClick={handleBlogsClick}
//             className={location.pathname === '/blogs' ? 'active' : ''}
//           >
//             {t.nav.blogs}
//           </a>
//           <a 
//             onClick={(e) => handleScrollTo(e, 'about')}
//           >
//             {t.nav.about}
//           </a>
//           <a 
//             onClick={handleContactClick}
//             className={location.pathname === '/contact' ? 'active' : ''}
//           >
//             {t.nav.contact}
//           </a>
//         </nav>
//       </header>
//     </>
//   );
// };

// export default Header;


// src/components/Header.jsx

import React, { useState } from 'react';
import { Globe, Menu, X } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import logo_icon from "../assets/s.png";
import content from "../data/content";
const Header = ({ content={} }) => {  // Add default empty object
  const navigate = useNavigate();
  const location = useLocation();
  const { language, setLanguage } = useLanguage();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Add safety check with default values
  const defaultContent = {
    nav: {
      home: 'Home',
      services: 'Services',
      blogs: 'Blogs',
      about: 'About',
      contact: 'Contact'
    }
  };

  const t = content[language] || content.en || content.mr || defaultContent;

  // Check if we're on the home page
  const isHomePage = location.pathname === '/';

  // Smooth scroll function for home page
  const handleScrollTo = (e, targetId) => {
    e.preventDefault();
    setIsMenuOpen(false);
    
    if (!isHomePage) {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(targetId);
        if (element) {
          element.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 100);
    } else {
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };

  const handleBlogsClick = (e) => {
    e.preventDefault();
    setIsMenuOpen(false);
    navigate('/blogs');
    window.scrollTo(0, 0);
  };

  const handleContactClick = (e) => {
    e.preventDefault();
    setIsMenuOpen(false);
    navigate('/contact');
    window.scrollTo(0, 0);
  };

  const handleLogoClick = (e) => {
    e.preventDefault();
    setIsMenuOpen(false);
    if (!isHomePage) {
      navigate('/');
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <>
      <style>{`
        .header {
          background: linear-gradient(135deg, #ffffff 0%, #fff5f2 100%);
          box-shadow: 0 4px 20px rgba(0,0,0,0.08);
          position: sticky;
          top: 0;
          z-index: 1000;
          backdrop-filter: blur(10px);
        }

        .header-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 16px 0;
          max-width: 1200px;
          margin: 0 auto;
          padding-left: 20px;
          padding-right: 20px;
        }

        .logo-section {
          display: flex;
          align-items: center;
          gap: 12px;
          cursor: pointer;
        }

        .logo-icon {
          width: 55px;
          height: 55px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .logo-icon img {
          width: 100%;
        }

        .logo-text h1 {
          font-size: 20px;
          color: #1a1a1a;
          font-weight: 700;
          background: linear-gradient(135deg, #1a1a1a 0%, #ff6b35 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin: 0 auto;
        }

        .logo-text p {
          font-size: 12px;
          color: #666;
          font-weight: bold;
          margin: 0 auto
        }

        .nav {
          display: flex;
          gap: 32px;
        }

        .nav a {
          color: #333;
          text-decoration: none;
          font-weight: 500;
          transition: color 0.3s;
          cursor: pointer;
          position: relative;
        }

        .nav a:hover {
          color: #ff6b35;
        }

        .nav a.active {
          color: #ff6b35;
        }

        .nav a.active::after {
          content: '';
          position: absolute;
          bottom: -8px;
          left: 0;
          right: 0;
          height: 3px;
          background: linear-gradient(90deg, #ff6b35, #ff8c42);
          border-radius: 2px;
        }

        .right-section {
          display: flex;
          align-items: center;
          gap: 5px;
        }

        .lang-btn {
          padding: 10px 20px;
          background: #fff5f2;
          color: #ff6b35;
          border: none;
          border-radius: 8px;
          font-weight: 600;
          cursor: pointer;
          transition: background 0.3s;
          font-family: 'Poppins', sans-serif;
        }

        .lang-btn:hover {
          background: #ffe5dc;
        }

        .hamburger-btn {
          display: none;
          background: none;
          border: none;
          cursor: pointer;
          padding: 8px;
          color: #333;
          transition: color 0.3s;
        }

        .hamburger-btn:hover {
          color: #ff6b35;
        }

        .mobile-nav {
          display: none;
          flex-direction: column;
          gap: 0;
          background: white;
          border-top: 1px solid #f0f0f0;
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        }

        .mobile-nav.open {
          display: flex;
        }

        .mobile-nav a {
          color: #333;
          text-decoration: none;
          padding: 16px 20px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.3s;
          border-bottom: 1px solid #f5f5f5;
        }

        .mobile-nav a:hover {
          background: #fff5f2;
          color: #ff6b35;
          padding-left: 30px;
        }

        .mobile-nav a.active {
          color: #ff6b35;
          background: #fff5f2;
        }

        @media (max-width: 768px) {
          .nav {
            display: none;
          }

          .hamburger-btn {
            display: block;
          }

          .logo-text h1 {
            font-size: 16px;
          }

          .logo-text p {
            font-size: 10px;
          }

          .logo-icon {
            width: 40px;
            height: 40px;
          }

          .lang-btn {
            padding: 8px 14px;
            font-size: 14px;
          }
        }
      `}</style>

      <header className="header">
        <div className="header-content">
          <div 
            className="logo-section"
            onClick={handleLogoClick}
          >
            <div className="logo-icon">
              <img src={logo_icon} alt='icon'/>
            </div>
            <div className="logo-text">
              <h1>{language === 'mr' ? 'श्री एंटरप्रायजेस' : 'Shree Enterprises'}</h1>
              <p>{language === 'mr' ? 'ई-सेवा केंद्र' : 'E-Seva Kendra'}</p>
            </div>
          </div>

          <nav className="nav">
            <a 
              onClick={(e) => handleScrollTo(e, 'home')}
              className={isHomePage ? 'active' : ''}
            >
              {t?.nav?.home || 'Home'}
            </a>
            <a 
              onClick={(e) => handleScrollTo(e, 'services')}
            >
              {t?.nav?.services || 'Services'}
            </a>
            <a 
              onClick={handleBlogsClick}
              className={location.pathname === '/blogs' ? 'active' : ''}
            >
              {t?.nav?.blogs || 'Blogs'}
            </a>
            <a 
              onClick={(e) => handleScrollTo(e, 'about')}
            >
              {t?.nav?.about || 'About'}
            </a>
            <a 
              onClick={handleContactClick}
              className={location.pathname === '/contact' ? 'active' : ''}
            >
              {t?.nav?.contact || 'Contact'}
            </a>
          </nav>

          <div className="right-section">
            <button 
              onClick={() => setLanguage(language === 'mr' ? 'en' : 'mr')} 
              className="lang-btn"
            >
              {language === 'mr' ? 'EN' : 'मराठी'}
            </button>

            <button 
              className="hamburger-btn"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>

        <nav className={`mobile-nav ${isMenuOpen ? 'open' : ''}`}>
          <a 
            onClick={(e) => handleScrollTo(e, 'home')}
            className={isHomePage ? 'active' : ''}
          >
            {t?.nav?.home || 'Home'}
          </a>
          <a 
            onClick={(e) => handleScrollTo(e, 'services')}
          >
            {t?.nav?.services || 'Services'}
          </a>
          <a 
            onClick={handleBlogsClick}
            className={location.pathname === '/blogs' ? 'active' : ''}
          >
            {t?.nav?.blogs || 'Blogs'}
          </a>
          <a 
            onClick={(e) => handleScrollTo(e, 'about')}
          >
            {t?.nav?.about || 'About'}
          </a>
          <a 
            onClick={handleContactClick}
            className={location.pathname === '/contact' ? 'active' : ''}
          >
            {t?.nav?.contact || 'Contact'}
          </a>
        </nav>
      </header>
    </>
  );
};

export default Header;